import styled from 'styled-components';

import { getThemeProp } from 'theme';

import {
  StyledDropdown as _StyledDropdown,
  StyledHeaderIcon as _StyledHeaderIcon,
} from '../HeaderDropdownMenu/styled';

export const StyledHeaderIcon = styled(_StyledHeaderIcon)`
  font-size: 20px;
  line-height: 20px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: ${getThemeProp('colors.moonRakerBlue')};
  }
`;

export const StyledDropdown = styled(_StyledDropdown)`
  && {
    .dropdown__trigger {
      padding: 0 4px;
    }

    .dropdown__content {
      right: -12px;
    }
  }
`;
